import React from "react";
import MetaTags from '../components/MetaTags';
import { organizationSchema } from '../data/structuredData';
import VideoHeroSection from "@/components/VideoHeroSection";
import AboutSection from "@/components/home/AboutSection";
import ActivitiesSection from "@/components/home/ActivitiesSection";
import FeaturedTour from "@/components/home/FeaturedTour";
import UpcomingToursSection from "@/components/home/UpcomingToursSection";
import BlogSection from "@/components/home/BlogSection";
import TestimonialSection from "@/components/home/TestimonialSection";
import CTASection from "@/components/home/CTASection";
const SafariMapSection = React.lazy(() => import("@/components/home/SafariMapSection"));
import Footer from "@/components/home/Footer";
import PartnersBanner from "@/components/home/PartnersBanner";
import { Suspense } from "react";

const Index: React.FC = () => {
  return (
    <>
      <MetaTags 
        title="Rion Wildlife Safaris | Premium African Safari Experiences"
        description="Experience unforgettable safari adventures in Namibia, Botswana and Victoria Falls with Rion Wildlife Safaris. Led by Professor Rion Haraeb with 20+ years of expertise."
        canonicalUrl="https://rionwildlifesafaris.com/"
        structuredData={organizationSchema}
      />
      
      <div className="bg-white flex flex-col items-center overflow-x-hidden">
        <VideoHeroSection />
        <AboutSection />
        <ActivitiesSection />
        <FeaturedTour />
        <UpcomingToursSection />
        <BlogSection />
        <TestimonialSection />
        <PartnersBanner />
        <CTASection />
        <Suspense fallback={<div className="w-full h-[450px] md:h-[600px] mt-[120px] max-md:mt-16 flex items-center justify-center bg-gray-50 rounded-lg">Loading interactive map...</div>}>
          <SafariMapSection />
        </Suspense>
        <Footer />
      </div>
    </>
  );
};

export default Index;
